import { useParams } from "react-router";
import Assets from "./Assets";
import Summary from "./Summary";
import useHeaderChange from "@/hooks/useHeaderChange";
import { useBalanceSheet } from "@/hooks/useBalanceSheet";
import Liabilities from "./Liabilities";
import BalanceSheetSkeleton from "./BalanceSheetSkeleton";
import NoDataMessage from "@/components/NoDataMessage";
import LifeInsurance from "./LifeInsurance";
import withDisclaimer from "@/hoc/withDisclaimer";
import PrintButton from "./PrintBSButton";

function BalanceSheet() {
  const { id } = useParams();
  const { upLoading, household } = useHeaderChange(id!, "Inventory of Assets and Liabilities");
  const { data: balData, isLoading, isError, isRefetching } = useBalanceSheet(id!, false);

  if (isLoading || isRefetching || upLoading) return <BalanceSheetSkeleton />;
  if (isError) return <div>Failed fetching Balance Sheet</div>;

  const {
    assets = [],
    liabilities = [],
    lifeInsurancePrimary = [],
    lifeInsuranceSecondary = [],
    summary,
    layout,
    totalAssetValue,
    totalLiabilities,
    totalLifeInsurancePrimary,
    totalLifeInsuranceSecondary,
  } = balData?.data ?? {};

  const hasNoData =
    !assets.length &&
    !liabilities.length &&
    !lifeInsurancePrimary.length &&
    !lifeInsuranceSecondary.length;

  if (hasNoData) return <NoDataMessage />;

  const getLifeInsuranceData = () => {
    const result = [];

    const primary = {
      data: lifeInsurancePrimary,
      title: household?.primaryContact?.preferredFirstName,
      total: totalLifeInsurancePrimary,
    };
    const secondary = {
      data: lifeInsuranceSecondary,
      title: household?.secondaryContact?.preferredFirstName,
      total: totalLifeInsuranceSecondary,
    };

    if (lifeInsurancePrimary != null) result.push(primary);
    if (lifeInsuranceSecondary != null) result.push(secondary);

    return result;
  };

  return (
    <div
      style={{ WebkitPrintColorAdjust: "exact" }}
      id="balance-sheet"
      className="print-zoom-85 break-before-column"
    >
      <div className="flex flex-col gap-8">
        <Assets
          assetGroups={assets}
          household={household}
          isNonAssetBal={false}
          layout={layout}
          total={totalAssetValue}
        />
        <div className="flex flex-col gap-8 sm:flex-row">
          <Liabilities liabilities={liabilities} totalLiabilities={totalLiabilities} />
          <LifeInsurance lifeInsurances={getLifeInsuranceData()} />
        </div>
        <Summary rows={summary?.rows} />
      </div>
      <PrintButton isNonAssetBalanceSheet={false} />
    </div>
  );
}

export default withDisclaimer(BalanceSheet);
